import { theme } from '@thg-commerce/gravity-theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

import { Property } from 'csstype'

export type ImageTextBlockThemeInterface = {
  title: {
    font: TextStyling
  }
  container: {
    backgroundColor: Property.Color
  }
}

export const ImageTextBlockTheme: ImageTextBlockThemeInterface = {
  title: {
    font: {
      entry: 'large1',
      style: 'alternate',
      textDecoration: 'none',
      transform: 'none',
      textColor: '#333333',
    },
  },
  container: {
    backgroundColor: theme.colors.palette.greys.lighter,
  },
}
